import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../Box/index.js";
import { CircularProgress } from "../CircularProgress/index.js";
const Loader = ()=>{
    const $ = c(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            justifyContent: "center",
            p: "32",
            className: "aqa_file_preview_loader",
            children: /*#__PURE__*/ jsx(CircularProgress, {
                size: 50
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
export { Loader };
